import React from "react";
import USPCard from "./USPCard";
import uspData from "../../data/uspData";

const USPSection = () => {
  return (
    <section className="usp">
      <div className="container">

        <div className="row">
          <div className="col-12">

            <h2>
              Caring for 45,000+ families annually with love.
            </h2>

            <p className="headText">
              We take pride in our commitment to providing exceptional service
              to our customers. We understand the importance of clean and safe
              drinking water, which is why we offer annual maintenance contracts
              to ensure that our customers' water purifiers are functioning
              optimally.
              <br />
              Our team of experts conducts servicing with care and love,
              making sure that our customers have access to the best possible
              water purifier services.
            </p>

          </div>
        </div>

        <div className="row">
          {uspData.map((item, index) => (
            <USPCard
              key={index}
              image={item.image}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default USPSection;